import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useHandshakeContext } from '@/components/HandshakeContext.js';
import { CONNECTION_EVENTS } from '@/handshake/protocol.js';
import { isRunningStandalone } from '@/handshake/mock-host.js';

/**
 * Notify the Kadanza Admin Console when the in-app path changes so the host
 * can sync breadcrumbs / browser history (see EXTENSION_GUIDE §10).
 */
export function HostNavigationSync() {
  const { pathname } = useLocation();
  const { hostOrigin, status } = useHandshakeContext();

  useEffect(() => {
    if (isRunningStandalone() || status !== 'connected' || !hostOrigin) return;

    try {
      window.parent.postMessage(
        { type: CONNECTION_EVENTS.navigationChange, payload: { path: pathname } },
        hostOrigin,
      );
    } catch (e) {
      console.warn('[navigation] failed to notify host', e);
    }
  }, [hostOrigin, pathname, status]);

  return null;
}
